import IvrList from './IvrList';

export default {
    list: IvrList,
    // show: IvrShow,
};
